import { Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import * as SHARED from "../../utils/shared";
import moment from "moment";

/**
 * createColumns
 * -------------
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 * @param {Function} handleConstanciaPrinted
 */
export function createColumns(page = 1, handleOpenInNewTab = null, handleGoDetail = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Estado",
      dataIndex: "idestado",
      key: "idestado",
      render: (state) => {
        let color = "";
        let text = "";
        switch (state) {
          case SHARED.ID_ESTADO_NO_INSCRITO:
            color = "default";
            text = "No inscrito";
            break;
          case SHARED.ID_ESTADO_VALIDADO:
            color = "green";
            text = "Validado";
            break;
          case SHARED.ID_ESTADO_PENDIENTE:
            color = "blue";
            text = "Pendiente";
            break;
          case SHARED.ID_ESTADO_OBSERVADO:
            color = "red";
            text = "Observado";
            break;
          case SHARED.ID_ESTADO_SORTEADO:
            color = "purple";
            text = "Sorteado";
            break;
          default:
            break;
        }
        return (
          <Tag color={color} key={state}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "Incompletos",
          value: SHARED.ID_ESTADO_NO_INSCRITO
        },
        {
          text: "Validados",
          value: SHARED.ID_ESTADO_VALIDADO
        },
        {
          text: "Pendientes",
          value: SHARED.ID_ESTADO_PENDIENTE
        },
        {
          text: "Observados",
          value: SHARED.ID_ESTADO_OBSERVADO
        },
        {
          text: "Sorteados",
          value: SHARED.ID_ESTADO_SORTEADO
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.idestado === value,
      sorter: (a, b) => {
        return a.idestado.length - b.idestado.length;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "DNI",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento),
      render: (record) => (
        <Button type="link" onClick={() => handleGoDetail(record.nrodocumento)}>
          {record.nrodocumento}
        </Button>
      )
    },
    {
      title: "Apellidos",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellidos.localeCompare(b.apellidos),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombres",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombres.localeCompare(b.nombres),
      sortDirections: ["descend", "ascend"]
    },
    // {
    //   title: "Fecha 1",
    //   dataIndex: "participafecha1",
    //   key: "participafecha1",
    //   render: (participafecha1) => {
    //     return (
    //       <div className="text-center">
    //         <Checkbox checked={participafecha1} />
    //       </div>
    //     );
    //   },
    //   filters: [
    //     {
    //       text: "Sí",
    //       value: true
    //     },
    //     {
    //       text: "No",
    //       value: false
    //     }
    //   ],
    //   filterMultiple: true,
    //   onFilter: (value, record) => record.participafecha1 === value,
    //   sorter: (a, b) => a.participafecha1 - b.participafecha1,
    //   sortDirections: ["descend", "ascend"]
    // },
    // {
    //   title: "Fecha 2",
    //   dataIndex: "participafecha2",
    //   key: "participafecha2",
    //   render: (participafecha2) => {
    //     return (
    //       <div className="text-center">
    //         <Checkbox checked={participafecha2} />
    //       </div>
    //     );
    //   },
    //   filters: [
    //     {
    //       text: "Sí",
    //       value: true
    //     },
    //     {
    //       text: "No",
    //       value: false
    //     }
    //   ],
    //   filterMultiple: true,
    //   onFilter: (value, record) => record.participafecha2 === value,
    //   sorter: (a, b) => a.participafecha2 - b.participafecha2,
    //   sortDirections: ["descend", "ascend"]
    // },
    {
      title: "Participación",
      dataIndex: "idtipoparticipacion",
      key: "idtipoparticipacion",
      render: (state) => {
        let color = "";
        let text = "";
        switch (state) {
          case SHARED.ID_INTERNAMIENTO:
            color = "blue";
            text = "Internamiento";
            break;
          case SHARED.ID_SUPERVISION:
            color = "green";
            text = "Supervisión";
            break;
          default:
            break;
        }
        return (
          <Tag color={color} key={state}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "Internamiento",
          value: SHARED.ID_INTERNAMIENTO
        },
        {
          text: "Supervisión",
          value: SHARED.ID_SUPERVISION
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.idtipoparticipacion === value,
      sorter: (a, b) => {
        return a.idtipoparticipacion.length - b.idtipoparticipacion.length;
      },
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Fecha registro",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => {
        return <p>{moment(createdAt).format("DD/MM/YYYY")}</p>;
      },
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      defaultSortOrder: "ascend"
    },
    // {
    //   title: "P. MEDICO",
    //   dataIndex: "personalmedico",
    //   key: "personalmedico",
    //   render: (personalmedico, record) => {
    //     return (
    //       <div className="text-center">
    //         <Checkbox checked={personalmedico} />
    //       </div>
    //     );
    //   },
    //   sorter: (a, b) => a.personalmedico - b.personalmedico,
    //   sortDirections: ["descend", "ascend"]
    // },
    {
      title: "Acciones",
      key: "action",
      render: (record) => (
        <Button icon={<EyeOutlined />} onClick={() => handleOpenInNewTab(record.nrodocumento)} />
      )
    }

    // {
    //   title: "Hace",
    //   dataIndex: "updatedAt",
    //   key: "updatedAt",
    //   render: (updatedAt) => {
    //     return <p>{moment(updatedAt).fromNow(true)}</p>;
    //   },
    //   sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
    //   defaultSortOrder: "ascend"
    // }
  ];
}
